import { Comments, Results, Token } from '@usimweb/core/models';

import * as fromResult from '../actions/result.action';

export interface ResultState {
  result: Results;
  versionComments: Comments[];
  projectsComments: Comments[];
  token: Token;
  loading: boolean;
  loaded: boolean;
}

export const initialState: ResultState = {
  result: {} as Results,
  token: {} as Token,
  versionComments: [],
  projectsComments: [],
  loading: false,
  loaded: false,
};

export function reducer(state = initialState, action: fromResult.ResultActions): ResultState {
  switch (action.type) {
    case fromResult.LOAD_RESULT_SUCCESS: {
      const result = action.payload;

      return {
        ...state,
        result,
      };
    }

    // update curves data here
    case fromResult.LOAD_CURVES_SUCCESS: {
      const curves = action.payload;

      console.log('result state');
      console.log(state);

      const results = { ...state.result.results[0], ['data']: [curves] };
      const result = { ...state.result, ['results']: [results] };

      console.log('result');
      console.log(result);

      return {
        ...state,
        result,
      };
    }
    case fromResult.LOAD_TOKEN_SUCCESS: {
      const token = action.payload;

      return {
        ...state,
        token,
      };
    }

    case fromResult.ADD_COMMENTS_SUCCESS: {
      const projectsComments = action.payload;

      return {
        ...state,
        projectsComments,
      };
    }

    case fromResult.CLEAR_RESULT: {
      return {
        ...state,
        result: {} as Results,
        token: {} as Token,
        loading: false,
        loaded: false,
      };
    }
  }

  return state;
}

export const getResult = (state: ResultState) => state.result;
export const getVersionComments = (state: ResultState) => state.versionComments;
export const getProjectsComments = (state: ResultState) => state.projectsComments;
export const getToken = (state: ResultState) => state.token;
export const getResultLoading = (state: ResultState) => state.loading;
export const geResultLoaded = (state: ResultState) => state.loaded;
